// Auto-generated from strings.properties
// Do not edit this file directly - edit strings.properties instead
const propertiesContent = `home.title=ELISA 选择工具
home.subtitle=ELISA 选择工具是一款非常实用的工具，能够根据您的实际需求，快速提供最适合您的定制 ELISA 检测方案。仅需根据实验需求回答一些简单问题，ELISA 选择工具即可推荐适合您实验方案的所需材料，从孔板到终止液，一应俱全。
home.about.title=查找最适合的 ELISA 试剂组合
home.about.get_started=开始

quiz.previous=上一步
quiz.next=下一步
quiz.submit=提交
quiz.edit=编辑
quiz.skip=跳过
quiz.unsure=不确定？
quiz.modal.link_title=不确定 ELISA 类型？
quiz.modal.link=了解更多
quiz.modal.title=ELISA 类型
quiz.modal.direct=直接检测
quiz.modal.indirect=间接检测
quiz.modal.capture=夹心检测
quiz.modal.body=<strong>常见 ELISA 格式图（直接检测 vs 夹心检测）</strong>。在检测中，目标抗原通过直接吸附固定在检测板上，或首先将捕获抗体附着在板表面。然后可以使用酶标记的一抗（直接检测）或未标记的一抗和酶标记的二抗组合（间接检测）来检测抗原。

quiz.q1.label=检测方法
quiz.q1.text=您喜欢使用哪种 ELISA 检测方法？
quiz.q1.colorimetric=比色法
quiz.q1.colorimetric.tooltip=最常用的检测方法。测量吸光度来定量。
quiz.q1.fluorescent=荧光法
quiz.q1.fluorescent.tooltip=提供宽的动态范围。需要使用荧光偶联体或荧光底物。
quiz.q1.chemiluminescent=化学发光法
quiz.q1.chemiluminescent.tooltip=最灵敏的宽动态范围检测方法
quiz.q2.label=孔板样式
quiz.q2.text=您喜欢用哪种 ELISA 孔板？
quiz.q2.96_well=96 孔板
quiz.q2.96_well_8_well_inserts=8 联排管
quiz.q2.96_well_8_well_inserts.tooltip=8 联排管可以拆卸。非常适合仅使用一部分孔的 ELISA 检测。并非每种预包被形式都有这种规格。
quiz.q2.384_well=384 孔板
quiz.q3.label=ELISA 检测类型
quiz.q3.text=您喜欢用哪种 ELISA 检测类型？
quiz.q3.sandwich=夹心 ELISA
quiz.q3.sandwich.tooltip=目标分析物结合在两种主要抗体之间，每种抗体各检测抗原的一种表位。
quiz.q3.direct=直接 ELISA
quiz.q3.direct.tooltip=将目标分析物固定在板上，采用经过标记的抗体直接检测。
quiz.q3.indirect=间接 ELISA
quiz.q3.indirect.tooltip=将目标分析物固定在板上，首先采用未标记的抗体（一抗）结合，再使用另一种经过标记的抗体（二抗）检测。
quiz.q4.label=包被方法
quiz.q4.text.a=您希望用什么方法在板上结合捕获抗体？
quiz.q4.text.b=您希望用什么方法在板上结合目标分析物？
quiz.q4.coat_antibody_directly_a=直接在板上包被抗体
quiz.q4.coat_antibody_directly_a.tooltip=这是最普遍的结合方法。由于非极性残基和塑料表面之间存在疏水作用，抗体可以吸附在塑料板上。
quiz.q4.coat_antibody_directly_b=直接在板上包被抗体
quiz.q4.biotinylated_streptavidin_neutravidin_a=在预包被链霉亲和素/中性亲和素的板上结合生物素化抗体
quiz.q4.biotinylated_streptavidin_neutravidin_a.tooltip=相比传统的抗体吸附方法，这种方法有更强的抗体结合能力。不兼容生物素化检测抗体。
quiz.q4.biotinylated_streptavidin_neutravidin_b=在预包被链霉亲和素/中性亲和素的板上结合生物素化抗体
quiz.q4.biotinylated_streptavidin_neutravidin_b.tooltip=抗体结合能力更强。非常适合疏水蛋白或肽。不兼容生物素化检测抗体。
quiz.q4.goat_anti_mouse_igg_a=在预包被山羊抗小鼠 IgG 的板上结合抗体
quiz.q4.goat_anti_mouse_igg_a.tooltip=非常适合仅有少量捕获抗体或捕获抗体吸附到板时已经变性（失活）的情况。
quiz.q4.goat_anti_mouse_igg_b=在预包被山羊抗小鼠 IgG 的板上结合抗体
quiz.q4.unsure=不确定/跳过
quiz.q4.coat_analyte_directly_a=直接在板上包被分析物
quiz.q4.coat_analyte_directly_b=直接在板上包被分析物
quiz.q4.coat_analyte_directly_b.tooltip=由于非极性残基和塑料表面之间存在疏水作用，蛋白或肽可以吸附在塑料板上。
quiz.q4.his_nickel_a=在使用镍预包被的板上结合 His 标记抗体
quiz.q4.his_nickel_b=在使用镍预包被的板上结合 His 标记抗体
quiz.q4.his_nickel_b.tooltip=非常适合裂解液或复杂的蛋白混合物。
quiz.q4.his_copper_a=在使用铜预包被的板上结合 His 标记抗体
quiz.q4.his_copper_b=在使用铜预包被的板上结合 His 标记抗体
quiz.q4.his_copper_b.tooltip=非常适合纯化的 His 标记蛋白或肽。
quiz.q4.gst_glutathione_a=在谷胱甘肽预包被的板上结合 GST 标记抗体
quiz.q4.gst_glutathione_b=在谷胱甘肽预包被的板上结合 GST 标记抗体
quiz.q4.gst_glutathione_b.tooltip=非常适合 GST 标记分析物。
quiz.q4.sulfhydryl_maleimide_a=在酰亚胺活化板上结合巯基官能团
quiz.q4.sulfhydryl_maleimide_b=在酰亚胺活化板上结合巯基官能团
quiz.q4.sulfhydryl_maleimide_b.tooltip=能够跟目标分析物中的巯基官能团形成共价键。
quiz.q4.amine_maleic_anhydride_a=在酸酐活化板上结合胺官能团
quiz.q4.amine_maleic_anhydride_b=在酸酐活化板上结合胺官能团
quiz.q4.amine_maleic_anhydride_b.tooltip=能够跟目标分析物中的胺官能团形成共价键。
quiz.q5.label=目标分析物丰度
quiz.q5.text=样品中的目标分析物丰度是什么样的？
quiz.q5.high=高
quiz.q5.medium=中
quiz.q5.low=低
quiz.q5.unsure=不确定
quiz.q6.label=检测抗体
quiz.q6.text=您使用的检测抗体是哪种？
quiz.q6.hrp=HRP-偶联体
quiz.q6.hrp.tooltip=辣根过氧化物酶 (HRP) 直接与检测抗体偶联。
quiz.q6.ap=AP-偶联体
quiz.q6.ap.tooltip=碱性磷酸酶 (AP) 直接与检测抗体偶联。
quiz.q6.biotinylated_hrp_streptavidin=生物素化检测抗体 + HRP-偶联链霉亲和素
quiz.q6.biotinylated_hrp_streptavidin.tooltip=能够放大信号；生物素化检测抗体与 HRP-偶联链霉亲和素偶联。
quiz.q6.biotinylated_ap_streptavidin=生物素化检测抗体 + AP-偶联链霉亲和素
quiz.q6.biotinylated_ap_streptavidin.tooltip=能够放大信号；生物素化检测抗体与 AP-偶联链霉亲和素偶联。
quiz.q6.fluorophore=荧光标记抗体
quiz.q6.fluorophore.tooltip=直接测量荧光强度获取结果。不需要添加任何底物。
quiz.skip_unsure=不确定？
quiz.skip_skip=跳过
quiz.ui.edit=编辑
quiz.ui.back=上一步
quiz.ui.next=下一步
quiz.ui.submit=提交
quiz.ui.of=第 页
quiz.modal.link_title=ELISA 检测类型不确定？
quiz.modal.link=了解更多
quiz.modal.title=ELISA 检测类型
quiz.modal.direct=直接检测
quiz.modal.indirect=间接检测
quiz.modal.capture=夹心捕获检测
quiz.modal.body=<strong>常见 ELISA 检测类型图解（直接检测和夹心捕获检测）</strong>。在直接检测中，目标抗原直接吸附到板上实现固定，可以使用酶联标记一抗检测目标抗原。而在夹心捕获检测中，捕获抗体先吸附到板上固定，目标抗原与捕获抗体结合。在间接检测中，需要先用未标记的一抗结合，再用经过标记的二抗检测。
results.title=推荐方案
results.summary.standard=<strong>根据您的回答</strong>，我们制定了最适合您需求的 ELISA 方案，包括了产品、试剂等方案所需材料。
results.start_over_label=重新开始
results.download_button=下载结果
results.download_protocol=下载方案
results.download_protocol.url=https://assets.thermofisher.com/TFS-Assets/BID/Technical-Notes/general-elisa-protocols-tech-note-zh.pdf
results.download_pdf_label=下载 PDF
results.download_xlsx_label=下载 XLSX 表格
results.preferences_label=编辑首选项
results.preferences.title=编辑首选项
results.preferences.edit=编辑
results.preferences.start_over=重新开始
results.preferences.confirm=确认
results.add_all_to_cart=添加所有产品
results.catalog_no=货号
results.add_to_cart=添加到购物车
results.add_to_list=保存为清单
results.group.best-solution=最佳解决方案
results.group.additional-products=您的 ELISA 检测方案可能还需要这些产品
results.shared_list.new_list.create_first=创建您的第一个产品清单
results.shared_list.new_list.name_placeholder=输入清单名称
results.shared_list.new_list.create=创建
results.shared_list.added_confirmation=添加到 
results.product.type.plate=板
results.product.type.wash-buffer=洗涤缓冲液
results.product.type.blocking-buffer=封闭缓冲液
results.product.type.streptavidin-conjugate=链霉亲和素
results.product.type.substrate=底物
results.product.type.stop-solution=终止液
results.product.type.reservoir=加样槽
results.product.type.sealer=孔板封膜机
results.product.type.elisa-buffer-kit=ELISA 缓冲液试剂盒
results.product.type.elisa-carbonate-coating-buffer=包被缓冲液
results.product.type.buph-carbonate-bicarbonate-buffer-packs=包被缓冲液
results.product.type.pierce-protein-free-tbs-blocking-buffer=封闭缓冲液
results.product.type.blocker-bsa-10x-in-tbs=BSA 封闭液
results.product.type.pierce-20x-tbs-buffer=TBS 缓冲液
results.product.type.pierce-20x-phosphate-buffered-saline=PBS 缓冲液
results.primary-antibodies=一抗
results.primary-antibodies.placeholder=搜索目标抗原
results.primary-antibodies.label=感兴趣的靶标
results.primary-antibodies.example_label=示例搜索
results.secondary-antibodies=二抗
results.secondary-antibodies.placeholder=搜索二抗
results.antibody-pairs=抗体对
results.antibody-pairs.btn=查看产品
results.recombinant-proteins=重组蛋白
results.recombinant-proteins.btn=查看产品
results.footer=您需要修改已经提交的内容吗？
results.footer.cta=编辑首选项

results.error.no_data=无法加载产品详细信息。
results.error.no_quiz=未找到问卷数据
results.error.complete_quiz=请先完成问卷。

results.pdf.tool_name=ELISA 选择工具
results.pdf.title=推荐方案
results.pdf.intro=<strong>根据您的回答</strong>，我们制定了最适合您需求的 ELISA 方案，包括了产品、试剂等方案所需材料。
results.pdf.table.product=产品
results.pdf.table.category=类别
results.pdf.table.unit_size=单位
results.pdf.table.catalog_no=货号
results.pdf.table.price=价格
results.pdf.page=页面
results.pdf.page_of=第 页
results.pdf.product.category.plate=板
results.pdf.product.category.wash-buffer=洗涤缓冲液
results.pdf.product.category.blocking-buffer=封闭缓冲液
results.pdf.product.category.streptavidin-conjugate=链霉亲和素
results.pdf.product.category.substrate=底物
results.pdf.product.category.stop-solution=终止液
results.pdf.product.category.reservoir=加样槽
results.pdf.product.category.sealer=孔板封膜机
results.pdf.product.category.elisa-buffer-kit=ELISA 缓冲液试剂盒
results.pdf.product.category.elisa-carbonate-coating-buffer=包被缓冲液
results.pdf.product.category.buph-carbonate-bicarbonate-buffer-packs=包被缓冲液
results.pdf.product.category.pierce-protein-free-tbs-blocking-buffer=封闭缓冲液
results.pdf.product.category.blocker-bsa-10x-in-tbs=洗涤缓冲液
results.pdf.product.category.pierce-20x-tbs-buffer=洗涤缓冲液
results.pdf.product.category.pierce-20x-phosphate-buffered-saline=洗涤缓冲液
results.pdf.card.primary-antibodies=一抗
results.pdf.card.secondary-antibodies=二抗
results.pdf.card.antibody-pairs=抗体对
results.pdf.card.antibody-pairs.link=elisa/query/*/filter/assaykit/matched+pair?persistFilters=yes
results.pdf.card.btn=查看产品
results.pdf.card.recombinant-proteins=重组蛋白
results.pdf.card.recombinant-proteins.link=proteins/query/*/filter/application/ELISA?persistFilters=yes
results.pdf.card.primary-antibodies.link=antibody/primary/filter/application/ELISA
results.pdf.card.secondary-antibodies.link=antibody/secondary/
results.quick-order-xlsx.quick-order.title=ELISA选择工具
results.quick-order-xlsx.quick-order.column.catalog_no=货号
results.quick-order-xlsx.quick-order.column.quantity=数量 (1 - 9999)
results.quick-order-xlsx.quick-order.column.product=产品
results.quick-order-xlsx.quick-order.column.unit_size_price=单位/价格
results.quick-order-xlsx.quick-order.additional-products-separator=您可能还需要这些产品用于ELISA
results.product_not_available=对不起，这个产品不能在网上订购，请 <a href="https://thermofisher.managed-otrs.com/external/">联系我们</a>.
results.group.additional-products=您的 ELISA 检测方案可能还需要这些产品
`;
export default propertiesContent;
